import { MaskInputType } from "../../../../components/finalForms/libs/data/formControlTypes";
import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { currencyDispayTypes, currencyTypes } from "../../../../lib/primelib/enum/currencyTypes.ENUM";
import { NumericValueTypes } from "../../../../lib/primelib/enum/numericValueTypes.ENUM";

const initState = {
  glAcctAR: '',
  glAcctSalesContract: '',
  glAcctContractDeferred: '',
  glAcctAP: '',
  glAcctSalesFlex: '',
  glAcctSalesFlexSmall: '',
  glAcctSalesRgd: '',
  glAcctSalesInst: '',
  glAcctSalesCam: '',
  glAcctSalesFlexOut: '',
  glAcctSalesFlexOutSmall: '',
  glAcctSalesRgdOut: '',
  glAcctSalesInstOut: '',
  glAcctSalesCamOut: '',
  glAcctPOFlex: '',
  glAcctPOFlexSmall: '',
  glAcctPORgd: '',
  glAcctPOInst: '',
  glAcctPOCam: '',
  glAcctPOFlexOut: '',
  glAcctPOFlexOutSmall: '',
  glAcctPORgdOut: '',
  glAcctPOInstOut: '',
  glAcctPOCamOut: '',
  glAcctCostOfScopesSold: '',
  glAcctServicePlanCredit: '',
  servicePlanMonthlyCost: '',
  glInstrumentForSale: '',
  glAcctExpenseShipping: '',
  glAcctSalesShip: '',
  salesTaxPayable: '',
  glAcctInstrumentsForSale: '',
  glAcctCostOfInstrumentsSold: '',
  pastDueDays: '',
  profitMarginPctDef: '',
  glAcctPOGeneralLab:'',
  glAcctPOCarts:''
};

export const GLAccountFormConfig = {
  name: "GL Account Form",
  initialState: initState,
  section: [
    {
      sectionId: "glAccountMatrixSection",
      title: "GL Account Matrix",
      style: { sectionStyle: "col-12 form-card" },
      wrapperTemplate: <div className="row"></div>,
      rowGroup: [
        {
          groupLabel: "Accounting Codes",
          style: { groupStyle: "col-12" },
          groupWrapper: <div className="form-sub-section row mx-1"></div>,
          fields: [
            {
              id: "glAcctAR",
              label: "AR :",
              Field_Name: "AR",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctAR",
              fieldSetting: { placeholder: "12000-300" },
              style: { containerCss: "col-md-3" },
            },
            {
              id: "glAcctSalesContract",
              label: "Contract :",
              Field_Name: "ContractCode",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesContract",
              fieldSetting: { placeholder: "40000-400" },
              style: { containerCss: "col-md-3" },
            },
            {
              id: "glAcctContractDeferred",
              label: "Contract Deferred :",
              Field_Name: "ContractDeferred",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctContractDeferred",
              fieldSetting: { placeholder: "21000-300" },
              style: { containerCss: "col-md-3" },
            },
            {
              id: "glAcctAP",
              label: "A/P for P.O. :",
              Field_Name: "APforPO",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctAP",
              fieldSetting: { placeholder: "20000-300" },
              style: { containerCss: "col-md-3" },
            },
            {
              fieldType: FormFieldTypes.SEPARATOR,
              style: {
                containerCss: "separation-line right-space-remove",
              },
            },
          ],
        },
        {
          groupLabel: "In-House 1",
          style: { groupStyle: "col-lg-3 col-md-6 mb-2" },
          groupWrapper: <div className="form-sub-section row ml-1"></div>,
          fields: [
            {
              id: "title",
              lable: "",
              Field_Name: "",
              fieldType: FormFieldTypes.MAINFORMTITLE,
              dataField: "",
              fieldSetting: {
                formTitle: "In-House",
              },
              style: {
                containerCss: "col-12 text-center mb-0",
              },
            },
            {
              fieldType: FormFieldTypes.SEPARATOR,
              style: {
                containerCss: "separation-line right-space-remove",
              },
            },
            {
              id: "glAcctSalesFlex",
              label: "Flexible (L) :",
              Field_Name: "FlexibleL1",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesFlex",
              fieldSetting: { placeholder: "40100-410" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesFlexSmall",
              label: "Flexible (S) :",
              Field_Name: "FlexibleS1",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesFlexSmall",
              fieldSetting: { placeholder: "40200-420" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesRgd",
              label: "Rigid :",
              Field_Name: "Rigid1",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesRgd",
              fieldSetting: { placeholder: "40300-430" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesInst",
              label: "Instrument :",
              Field_Name: "Instrument1",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesInst",
              fieldSetting: { placeholder: "40500-450" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesCam",
              label: "Camera :",
              Field_Name: "Camera1",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesCam",
              fieldSetting: { placeholder: "40400-440" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glCarts",
              label: "Endocarts :",
              Field_Name: "Carts",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glCarts",
              fieldSetting: { placeholder: "50200-460" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "mobileVan",
              label: "Mobile Van :",
              Field_Name: "mobileVan",
              fieldType: FormFieldTypes.INPUT,
              dataField: "mobileVan",
              fieldSetting: { placeholder: "50220-440" },
              style: { containerCss: "col-12 mb-2" },
            },
          ],
        },
        {
          groupLabel: "In-House 2",
          style: { groupStyle: "col-lg-3 col-md-6 mb-2" },
          groupWrapper: <div className="form-sub-section row"></div>,
          fields: [
            {
              id: "title",
              lable: "",
              Field_Name: "",
              fieldType: FormFieldTypes.MAINFORMTITLE,
              dataField: "",
              fieldSetting: {
                formTitle: "Outsourced",
              },
              style: {
                containerCss: "col-12 text-center mb-0",
              },
            },
            {
              fieldType: FormFieldTypes.SEPARATOR,
              style: {
                containerCss: "separation-line right-space-remove",
              },
            },
            {
              id: "glAcctSalesFlexOut",
              label: "Flexible (L) :",
              Field_Name: "FlexibleL5",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesFlexOut",
              fieldSetting: { placeholder: "50200-410" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesFlexOutSmall",
              label: "Flexible (S) :",
              Field_Name: "FlexibleS5",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesFlexOutSmall",
              fieldSetting: { placeholder: "50200-420" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesRgdOut",
              label: "Rigid :",
              Field_Name: "Rigid5",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesRgdOut",
              fieldSetting: { placeholder: "50200-430" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesInstOut",
              label: "Instrument :",
              Field_Name: "Instrument5",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesInstOut",
              fieldSetting: { placeholder: "50200-450" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesCamOut",
              label: "Camera :",
              Field_Name: "Camera5",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesCamOut",
              fieldSetting: { placeholder: "50200-440" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glCarts1",
              label: "Endocarts :",
              Field_Name: "Carts",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glCarts1",
              fieldSetting: { placeholder: "50200-460" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "mobileVan",
              label: "Mobile Van :",
              Field_Name: "mobileVan",
              fieldType: FormFieldTypes.INPUT,
              dataField: "mobileVan",
              fieldSetting: { placeholder: "50220-440" },
              style: { containerCss: "col-12 mb-2" },
            },
          ],
        },
        {
          groupLabel: "In-House 3",
          style: { groupStyle: "col-lg-3 col-md-6 mb-2" },
          groupWrapper: <div className="form-sub-section row"></div>,
          fields: [
            {
              id: "title",
              lable: "",
              Field_Name: "",
              fieldType: FormFieldTypes.MAINFORMTITLE,
              dataField: "",
              fieldSetting: {
                formTitle: "P.O. Expense Accts - Parts",
              },
              style: {
                containerCss: "col-12 text-center mb-0",
              },
            },
            {
              fieldType: FormFieldTypes.SEPARATOR,
              style: {
                containerCss: "separation-line right-space-remove",
              },
            },
            {
              id: "glAcctPOFlex",
              label: "Flexible (L) :",
              Field_Name: "FlexibleL6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOFlex",
              fieldSetting: { placeholder: "50220-410" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPOFlexSmall",
              label: "Flexible (S) :",
              Field_Name: "FlexibleS6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOFlexSmall",
              fieldSetting: { placeholder: "50220-420" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPORgd",
              label: "Rigid :",
              Field_Name: "Rigid6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPORgd",
              fieldSetting: { placeholder: "50220-430" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPOInst",
              label: "Instrument :",
              Field_Name: "Instrument6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOInst",
              fieldSetting: { placeholder: "50220-450" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPOCam",
              label: "Camera :",
              Field_Name: "Camera6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOCam",
              fieldSetting: { placeholder: "50220-440" },
              style: { containerCss: "col-12 mb-2" },
            },

            // {
            //   id: "glCogentix",
            //   label: "Cogentix :",
            //   Field_Name: "Cogentix",
            //   fieldType: FormFieldTypes.INPUT,
            //   dataField: "glCogentix",
            //   fieldSetting: { placeholder: "50200-470" },
            //   style: { containerCss: "col-12 mb-2" },
            // },
            // {
            //   id: "glFuse",
            //   label: "FUSE :",
            //   Field_Name: "FUSE",
            //   fieldType: FormFieldTypes.INPUT,
            //   dataField: "glFuse",
            //   fieldSetting: { placeholder: "50200-480" },
            //   style: { containerCss: "col-12 mb-2" },
            // },
            {
              id: "glAcctPOCarts",
              label: "Endocarts :",
              Field_Name: "Carts",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOCarts",
              fieldSetting: { placeholder: "50200-460" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPOGeneralLab",
              label: "General Lab :",
              Field_Name: "GeneralLab",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOGeneralLab",
              fieldSetting: { placeholder: "50200-440" },
              style: { containerCss: "col-12 mb-2" },
            },
          ],
        },
        {
          groupLabel: "Others",
          style: { groupStyle: "col-lg-3 col-md-6 mb-2" },
          groupWrapper: <div className="form-sub-section row mr-1"></div>,
          fields: [
            {
              id: "title",
              lable: "",
              Field_Name: "",
              fieldType: FormFieldTypes.MAINFORMTITLE,
              dataField: "",
              fieldSetting: {
                formTitle: "P.O. Expense Accts - Outsourced",
              },
              style: {
                containerCss: "col-12 text-center mb-0",
              },
            },
            {
              fieldType: FormFieldTypes.SEPARATOR,
              style: {
                containerCss: "separation-line right-space-remove",
              },
            },
            {
              id: "glAcctPOFlexOut",
              label: "Flexible (L) :",
              Field_Name: "FlexibleL6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOFlexOut",
              fieldSetting: { placeholder: "50220-410" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPOFlexOutSmall",
              label: "Flexible (S) :",
              Field_Name: "FlexibleS6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOFlexOutSmall",
              fieldSetting: { placeholder: "50220-420" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPORgdOut",
              label: "Rigid :",
              Field_Name: "Rigid6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPORgdOut",
              fieldSetting: { placeholder: "50220-430" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPOInstOut",
              label: "Instrument :",
              Field_Name: "Instrument6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOInstOut",
              fieldSetting: { placeholder: "50220-450" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctPOCamOut",
              label: "Camera :",
              Field_Name: "Camera6",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctPOCamOut",
              fieldSetting: { placeholder: "50220-440" },
              style: { containerCss: "col-12 mb-2" },
            },

          ],
        },
      ],
    },

    {
      sectionId: "smallBoxSection",
      title: "",
      style: { sectionStyle: "col-6 mt-3" },
      wrapperTemplate: <div className="row form-card mr-1"></div>, // adds spacing between cards
      rowGroup: [
        // {
        //   groupLabel: "Fuse",
        //   style: { groupStyle: "col-lg-6 col-md-6 mb-2" },
        //   groupWrapper: <div className="form-sub-section row pr-1 border-rx-1"></div>,
        //   fields: [
        //     {
        //       id: "title",
        //       lable: "",
        //       Field_Name: "",
        //       fieldType: FormFieldTypes.MAINFORMTITLE,
        //       dataField: "",
        //       fieldSetting: {
        //         formTitle: "Fuse",
        //       },
        //       style: {
        //         containerCss: "col-lg-12 col-md-12 text-center mb-0",
        //       },
        //     },
        //     {
        //       fieldType: FormFieldTypes.SEPARATOR,
        //       style: {
        //         containerCss: "separation-line right-space-remove",
        //       },
        //     },
        //     {
        //       id: "glContract",
        //       label: "Contract :",
        //       Field_Name: "Contract",
        //       fieldType: FormFieldTypes.INPUT,
        //       dataField: "glContract",
        //       fieldSetting: { placeholder: "40000-480" },
        //       style: { containerCss: "col-12 mb-2" },
        //     },
        //     {
        //       id: "glTM",
        //       label: "T&M :",
        //       Field_Name: "TM",
        //       fieldType: FormFieldTypes.INPUT,
        //       dataField: "glTM",
        //       fieldSetting: { placeholder: "40710-480" },
        //       style: { containerCss: "col-12 mb-2" },
        //     },
        //     {
        //       id: "glOutsideUS",
        //       label: "Outside US :",
        //       Field_Name: "OutsideUS",
        //       fieldType: FormFieldTypes.INPUT,
        //       dataField: "glOutsideUS",
        //       fieldSetting: { placeholder: "40700-480" },
        //       style: { containerCss: "col-12 pb-3" },
        //     },
        //   ],
        // },
        {
          groupLabel: "Acquisitions",
          style: { groupStyle: "col-lg-12 col-md-6 mb-2" },
          groupWrapper: <div className="form-sub-section row mr-1"></div>,
          fields: [
            {
              id: "title",
              lable: "",
              Field_Name: "",
              fieldType: FormFieldTypes.MAINFORMTITLE,
              dataField: "",
              fieldSetting: {
                formTitle: "Acquisitions",
              },
              style: {
                containerCss: "col-12 text-center mb-0",
              },
            },
            {
              fieldType: FormFieldTypes.SEPARATOR,
              style: {
                containerCss: "separation-line right-space-remove",
              },
            },
            {
              id: "glAcctCostOfScopesSold",
              label: "Cost of Scopes Sold :",
              Field_Name: "CostScopesSold",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctCostOfScopesSold",
              fieldSetting: { placeholder: "50210-400" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctServicePlanCredit",
              label: "Service Plan Credit :",
              Field_Name: "ServicePlanCredit",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctServicePlanCredit",
              fieldSetting: { placeholder: "21010-300" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "servicePlanMonthlyCost",
              label: "Service Plan Mo. Cost :",
              Field_Name: "ServicePlanMoCost",
              fieldType: FormFieldTypes.PRIMENUMBERINPUT,
              dataField: "servicePlanMonthlyCost",
              style: { containerCss: "col-12 validation-left-0" },
              fieldSetting: {
                placeholder: "$75.00",
                fieldConfig: {
                  useGrouping: true,
                  minFractionDigits: 2,
                  maxFractionDigits: 2,
                  mode: NumericValueTypes.CURRENCY,
                  currency: currencyTypes.USD,
                  currencyFormat: currencyDispayTypes.SYMBOL,
                }
              },
            },
          ],
        },


      ],
    },
    {
      sectionId: "smallBoxSection",
      title: "",
      style: { sectionStyle: "col-6 mt-3" },
      wrapperTemplate: <div className="row form-card"></div>, // adds spacing between cards
      rowGroup: [
        {
          groupLabel: "Summary",
          style: { groupStyle: "col-lg-12 col-md-12 mb-2 summery-section-bottom" },
          groupWrapper: <div className="form-sub-section row"></div>,
          fields: [
            {
              id: "title",
              lable: "",
              Field_Name: "",
              fieldType: FormFieldTypes.MAINFORMTITLE,
              dataField: "",
              fieldSetting: {
                formTitle: "Miscellaneous",
              },
              style: {
                containerCss: "col-lg-12 col-md-12 text-center mb-0",
              },
            },
            {
              fieldType: FormFieldTypes.SEPARATOR,
              style: {
                containerCss: "separation-line right-space-remove",
              },
            },
            {
              id: "glAcctExpenseShipping",
              label: "Expense Shipping :",
              Field_Name: "ExpenseShipping",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctExpenseShipping",
              fieldSetting: { placeholder: "50410-400" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctSalesShip",
              label: "Shipping :",
              Field_Name: "Shipping",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctSalesShip",
              fieldSetting: { placeholder: "42000-400" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "salesTaxPayable",
              label: "Sales Tax Payable :",
              Field_Name: "SalesTaxPayable",
              fieldType: FormFieldTypes.INPUT,
              dataField: "salesTaxPayable",
              fieldSetting: { placeholder: "22000-300" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctInstrumentsForSale",
              label: "Instrument Available for Sale :",
              Field_Name: "InstrumentForSale",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctInstrumentsForSale",
              fieldSetting: { placeholder: "13200-450" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "glAcctCostOfInstrumentsSold",
              label: "Cost of Instruments Sold :",
              Field_Name: "CostOfInstrumentsSold",
              fieldType: FormFieldTypes.INPUT,
              dataField: "glAcctCostOfInstrumentsSold",
              fieldSetting: { placeholder: "50210-450" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "pastDueDays",
              label: "Past Due Days :",
              Field_Name: "PastDueDays",
              fieldType: FormFieldTypes.INPUT,
              dataField: "pastDueDays",
              fieldSetting: { placeholder: "60" },
              style: { containerCss: "col-12 mb-2" },
            },
            {
              id: "profitMarginPctDef",
              label: "Profit Margin % :",
              Field_Name: "ProfitMargin",
              fieldType: FormFieldTypes.PRIMENUMBERINPUT,
              dataField: "profitMarginPctDef",
              fieldSetting: {
                placeholder: "40.00%",
                min: 0,
                max: 100,
                fieldConfig: {
                    useGrouping: false,
                    minFractionDigits: 2,
                    maxFractionDigits: 2,
                    mode: NumericValueTypes.DECIMAL,
                    suffix: "%",
                  },
              },
              style: { containerCss: "col-12 validation-left-0" },
            },
          ],
        },

      ],
    },
  ],
};
